// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-toggle {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    color: var(--text-main);
    backdrop-filter: blur(5px);
}

[data-theme="light"] .theme-toggle {
    background: rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.1);
    color: var(--text-main);
}

.theme-toggle:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: scale(1.05);
    box-shadow: 0 0 15px var(--primary);
}

[data-theme="light"] .theme-toggle:hover {
    background: rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 15px rgba(99, 102, 241, 0.3);
}

.theme-icon {
    transition: transform 0.5s ease;
}

.theme-toggle:active .theme-icon {
    transform: rotate(90deg) scale(0.8);
}`, "",{"version":3,"sources":["webpack://./src/components/ThemeToggle.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iDAAiD;IACjD,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,mCAAmC;AACvC;;AAEA;IACI,8BAA8B;IAC9B,4CAA4C;AAChD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":[".theme-toggle {\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    color: var(--text-main);\n    backdrop-filter: blur(5px);\n}\n\n[data-theme=\"light\"] .theme-toggle {\n    background: rgba(0, 0, 0, 0.05);\n    border-color: rgba(0, 0, 0, 0.1);\n    color: var(--text-main);\n}\n\n.theme-toggle:hover {\n    background: rgba(255, 255, 255, 0.2);\n    transform: scale(1.05);\n    box-shadow: 0 0 15px var(--primary);\n}\n\n[data-theme=\"light\"] .theme-toggle:hover {\n    background: rgba(0, 0, 0, 0.1);\n    box-shadow: 0 0 15px rgba(99, 102, 241, 0.3);\n}\n\n.theme-icon {\n    transition: transform 0.5s ease;\n}\n\n.theme-toggle:active .theme-icon {\n    transform: rotate(90deg) scale(0.8);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
